import React, { Fragment } from 'react';
import { Link } from 'react-router-dom';
import { withNamespaces } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronRight } from '@fortawesome/pro-light-svg-icons/faChevronRight';
import { faArrowLeft } from '@fortawesome/pro-light-svg-icons/faArrowLeft';
import { faInfoCircle } from '@fortawesome/pro-light-svg-icons/faInfoCircle';
import { BreadcrumbContext } from '../../App';


const renderBackButton = (breadcrumbs, t, goBack) => {
  if (!breadcrumbs || breadcrumbs.length < 2) {
    return null;
  }

  const { to: pathname, labelId, text } = goBack || breadcrumbs[0];
  const finalText = labelId ? t(labelId) : text;
  return (
    <Link to={{ pathname, state: { fromBackButton: true } }}>
      <Fragment>
        <FontAwesomeIcon icon={faArrowLeft} />
        &nbsp;{t('labelBackTo')} {finalText}
      </Fragment>
    </Link>
  );
};

const redirectToFaq = (faqUrl) => {
  let url = window.location.origin;
  url = `${url}${faqUrl}`;
  window.open(url, '_blank');
};

const renderBreadcrumbs = (breadcrumbs, t, goBack, showFaq, faqUrl, showGoBack = true) => {
  if (!breadcrumbs) {
    return null;
  }
  const breadcrumbIcon = showFaq || breadcrumbs[0].showFaq;
  const breadcrumbUrl = faqUrl || breadcrumbs[0].faqUrl;
  return (
    <div className="breadcrumb-layout-container">
      <div className="breadcrumb-area">
        <div className="items">
          {
            breadcrumbs.map(({ to, labelId, text }, index) => {
              const finalText = labelId ? t(labelId) : text;
              const element = to
                ? <Link to={{ pathname: to, state: { fromBackButton: index === 0 && true } }}>{finalText}</Link>
                : <span>{finalText}</span>;
              return (
                <Fragment key={text || labelId}>
                  {element} { breadcrumbIcon && <FontAwesomeIcon icon={faInfoCircle} size="1x" className="faq-bredcrum-icon" onClick={() => { redirectToFaq(breadcrumbUrl); }} />}
                  {
                    index + 1 < breadcrumbs.length
                      ? (
                        <span className="divider">
                          <FontAwesomeIcon icon={faChevronRight} size="xs" />
                        </span>
                      )
                      : null
                  }
                </Fragment>
              );
            })
          }
        </div>
        <div className="back">
          {showGoBack && renderBackButton(breadcrumbs, t, goBack)}
        </div>
      </div>
    </div>
  );
};

const BreadcrumbArea = ({ t, goBack, showFaq, faqUrl, showGoBack }) => {
  return (
    <BreadcrumbContext.Consumer>
      {
        value => renderBreadcrumbs(value, t, goBack, showFaq, faqUrl, showGoBack)
      }
    </BreadcrumbContext.Consumer>
  );
};

export default withNamespaces()(BreadcrumbArea);
